import { Component, Input } from '@angular/core';

import { ComponentVariantEnum } from '~/component/enums/variant';
import { range } from '~/core/helpers/array/array.helper';

@Component({
  selector: 'app-stepper-title',
  templateUrl: './title.component.html',
  styleUrls: ['./title.component.scss'],
})
export class StepperTitleComponent {
  @Input() public active = 0;
  @Input() public stepsNumber: number;
  @Input() public variant = ComponentVariantEnum.Dark;

  public get isDarkMode(): boolean {
    return this.variant === ComponentVariantEnum.Dark;
  }

  public get isLightMode(): boolean {
    return this.variant === ComponentVariantEnum.Light;
  }

  public get steps(): number[] {
    return range(1, this.stepsNumber);
  }
}
